import React, { useCallback, useEffect, useState } from 'react'

import { DesktopH2 } from 'components/UI/Typography/Typography.new'
import useResponsive from 'hooks/useResponsive'

import styles from './NameFlip.module.css'

const MARGIN_OFFSET = 20

type NameFlipProps = {
  names: string[]
  color?: string
}

const NameFlip = ({ names, color }: NameFlipProps): JSX.Element => {
  const { isMobile } = useResponsive()
  const H2HEIGHT = (isMobile ? 30 : 56) + MARGIN_OFFSET
  const [index, setIndex] = useState(1)
  const [offset, setOffset] = useState(H2HEIGHT * index)
  const [shouldAnimate, setShouldAnimate] = useState(false)

  const handleTick = useCallback(() => {
    setOffset(H2HEIGHT * index)
    if (index + 1 >= names.length) {
      setShouldAnimate(false)
      names.unshift(names.pop())
      setIndex(1)
    } else {
      setShouldAnimate(true)
      setIndex(index + 1)
    }
  }, [index, names, H2HEIGHT])

  // Start and clear the timer
  useEffect(() => {
    const timer = setTimeout(handleTick, 1000)
    return () => {
      clearTimeout(timer)
    }
  }, [handleTick])

  return (
    <div className={styles.container}>
      <div
        className={`${styles.namesContainer} ${
          shouldAnimate ? styles.animated : ''
        }`}
        style={{ transform: `translateY(-${offset}px)` }}
      >
        {names.map((name) => (
          <div key={name} className={styles.nameWrapper}>
            <DesktopH2 element="h2" strict theme="primary">
              <div className={styles.nameSwitcher} style={{ color }}>
                {name}
              </div>
            </DesktopH2>
          </div>
        ))}
      </div>
    </div>
  )
}

export default NameFlip
